"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPeriodPickerView = void 0;
const Card_1 = require("@amzn/atoz-web/Card");
const Col_1 = require("@amzn/atoz-web/Col");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Text_1 = require("@amzn/atoz-web/Text");
const Button_1 = require("@amzn/atoz-web/Button");
const Link_1 = require("@amzn/atoz-web/Link");
const Theme_1 = require("@amzn/atoz-web/Theme");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const utils_1 = require("../../utils");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const consts_1 = require("../../consts");
const SpinnerOverlay_1 = require("../SpinnerOverlay");
const PayPeriodPickerViewTypes_1 = require("./PayPeriodPickerViewTypes");
const BIAnalytics_1 = require("../../utils/BIAnalytics/BIAnalytics");
const PayPeriodPickerView = ({ selectedPayPeriod, isLoading, payPeriodOffset, setPayPeriodOffset, availablePayPeriodsNumber, isSeePayForWebEnabled }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxPayPeriodOffset = availablePayPeriodsNumber - 1;
    const CURRENT_PAY_PERIOD_OFFSET = 0;
    const payPeriodText = payPeriodOffset == CURRENT_PAY_PERIOD_OFFSET
        ? t('time_and_attendance_Timecard_PayPeriod_Picker_CurrentPayPeriod')
        : t('time_and_attendance_Timecard_PayPeriod_Picker_PastPayPeriod');
    const payDayText = payPeriodOffset == CURRENT_PAY_PERIOD_OFFSET
        ? t('time_and_attendance_Timecard_PayPeriod_Picker_PayDay')
        : t('time_and_attendance_Timecard_PayPeriod_Picker_Paid');
    const seePreviousPayPeriod = () => {
        var _a;
        setPayPeriodOffset(payPeriodOffset + 1);
        (_a = BIAnalytics_1.BIAnalytics.goToPreviousPayPeriod) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
    };
    const seeNextPayPeriod = () => {
        var _a;
        setPayPeriodOffset(payPeriodOffset - 1);
        (_a = BIAnalytics_1.BIAnalytics.goToNextPayPeriod) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
    };
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, react_1.useEffect)(() => {
        if (isSeePayForWebEnabled) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.TIMECARD_SEE_PAY_LINK_SEEN.COUNT,
                dimensions
            });
        }
    }, []);
    const recordSeePayLinkMetrics = () => {
        var _a;
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.TIMECARD_SEE_PAY_LINK_CLICK.COUNT,
            dimensions
        });
        (_a = BIAnalytics_1.BIAnalytics.clickSeePayLink) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
    };
    return (react_1.default.createElement(StyledCard, null,
        react_1.default.createElement(StyledButton, { dataTestId: "previousPayPeriodButton", disabled: payPeriodOffset >= maxPayPeriodOffset, size: Button_1.ButtonSize.Small, variant: Button_1.ButtonVariant.Tertiary, onClick: seePreviousPayPeriod, icon: react_1.default.createElement(Icons_1.IconChevronLeft, { dataTestId: "previous-payPeriod-icon" }), "aria-label": t('time_and_attendance_Timecard_PayPeriod_Picker_PreviousPayPeriod') }),
        react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
            react_1.default.createElement(Col_1.Col, { dataTestId: PayPeriodPickerViewTypes_1.PAY_PERIOD_PICKER_TEST_ID, padding: "S200", alignItems: "center" },
                react_1.default.createElement(Text_1.H1, { fontSize: "T500" },
                    react_1.default.createElement("strong", null, selectedPayPeriod && (0, utils_1.getSelectedPayPeriodText)(selectedPayPeriod))),
                selectedPayPeriod && (react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral80" }, selectedPayPeriod &&
                    (!!selectedPayPeriod.payDate
                        ? `${payPeriodText} | ${payDayText} ${(0, utils_1.getSelectedPayDayText)(selectedPayPeriod)}`
                        : `${payPeriodText}`))),
                isSeePayForWebEnabled && (react_1.default.createElement(Link_1.Link, { dataTestId: "see-pay-link", textDecoration: "none", fontSize: "T100", href: consts_1.ATOZ_FEATURE_PATH.PAY, "aria-label": t('time_and_attendance_Timecard_PayPeriod_Picker_SeePay'), onClick: recordSeePayLinkMetrics }, t('time_and_attendance_Timecard_PayPeriod_Picker_SeePay'))))),
        react_1.default.createElement(StyledButton, { dataTestId: "nextPayPeriodButton", disabled: payPeriodOffset === CURRENT_PAY_PERIOD_OFFSET, size: Button_1.ButtonSize.Small, variant: Button_1.ButtonVariant.Tertiary, onClick: seeNextPayPeriod, icon: react_1.default.createElement(Icons_1.IconChevronRight, { dataTestId: "next-payPeriod-icon" }), "aria-label": t('time_and_attendance_Timecard_PayPeriod_Picker_NextPayPeriod') })));
};
exports.PayPeriodPickerView = PayPeriodPickerView;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   display:flex;
   align-items:center;
   border: none;
`);
const StyledButton = (0, Theme_1.styledWithTheme)(Button_1.Button)(({ theme }) => `
     border: none;
     border-radius: 2px;
     height: 10px
  `);
